export default {
      id: "support-24-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.4f7c228b.svg#support-24",
      toString: function () {
        return this.url;
      }
    }